<template>
  <Button
    :type="type"
    :class="buttonClasses"
    :disabled="disabled"
    @click="handleClick"
    :label="loading ? $t('commonLabels.loading') : label"
    v-bind="$attrs"
    :icon="icon"
    :iconPos="iconPos"
    :rounded="rounded"
    :variant="variant"
    :aria-label="props.ariaLabel || (label ? `button-${label}` : '')"
    :name="name"
    :data-test-id="formatTestId(name)"
    :size="mappedSize"
    :loading="loading"
    :pt="{ label: { class: labelClass } }"
  >
    <template #default>
      <slot></slot>
    </template>
  </Button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  type: { type: String, default: "button" },
  label: { type: String, default: "" },
  color: { type: String, default: "primary" },
  class: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  icon: { type: String, default: "" },
  iconPos: { type: String, default: "left" },
  rounded: { type: Boolean, default: true },
  variant: { type: String, default: "" },
  ariaLabel: { type: String, default: "" },
  name: { type: String, default: "" },
  size: {
    type: String,
    default: "",
    validator: (value) => ["s", "m", "l", ""].includes(value),
  },
  labelClass: { default: "!font-400" },
});

const sizeClassMap = {
  s: "small",
  m: "",
  l: "large",
};

const mappedSize = computed(() => sizeClassMap[props.size] || "");

const emit = defineEmits(["click"]);

const buttonClasses = computed(() => [
  "transition-colors duration-200 h-[48px] text-base  !font-just text-sunriseGlow ",
  "disabled:!cursor-not-allowed disabled:!bg-btnDisabled",
  "bg-btnActive hover:bg-lightGrey disabled:!bg-btnDisabled",
  {
    "btn-s": props.size === "s",
    "btn-m": props.size === "m",
    "btn-l": props.size === "l",
    "btn-xl": props.size === "xl",
    "opacity-75": props.loading,
  },
  "!border-0",
  props.class,
]);

const handleClick = (event) => {
  if (!props.loading) {
    emit("click", event);
  }
};

const formatTestId = (name) => {
  if (!name) return "";
  return name.replace(/\s+/g, "_") + "-btn";
};
</script>
